import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FileProgressEvent, FileSelectEvent, FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import {
    ClearanceDownloadUrlCallback,
    GoogleCloudStorageService
} from 'src/app/services/google/google-cloud-storage.service';
import { CustomsClearanceFileTypes } from '../../clearance/models/customs-clearance-file-type';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-shipment-file-upload',
    templateUrl: './clearance-file-upload.component.html',
    styleUrls: ['./clearance-file-upload.component.css'],
    standalone: true,
    providers: [MessageService],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectModule,
        FileUploadModule
    ]
})
export class ClearanceFileUploadComponent {

    filesSelected = false;
    uploadedFiles: any[] = [];
    fileTypes: string[] = [];
    selectedFileType: string = '';
    uploadProgress: number = 0;

    clearanceDownloadUrlCallback: ClearanceDownloadUrlCallback;


    constructor(private sessionStorageService: SessionStorageService,
        private messageService: MessageService, private config: DynamicDialogConfig,
        private googleCloudStorageService: GoogleCloudStorageService) {
        this.clearanceDownloadUrlCallback = config.data.callback;
        this.fileTypes = Object.values(CustomsClearanceFileTypes.map(fileType => fileType.label));
    }

    ngOnInit(): void { }

    onClearanceFileUpload(event: FileUploadHandlerEvent) {
        for (let i = 0; i < event.files.length; i++) {
            let file = event.files.at(i)!!;
            let clearanceHeader = this.sessionStorageService.getCurrentClearanceHeader()!!;
            let clearanceDetail = this.sessionStorageService.getCurrentClearanceDetail();
            this.googleCloudStorageService.uploadClearanceFile(file, file.name, this.selectedFileType,
                null, this.uploadProgress, clearanceHeader.clearanceHeaderID, clearanceDetail?.clearanceDetailID, (clearanceFile) => {
                    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File ' + file.name + ' is uploaded successfully' });
                    this.clearanceDownloadUrlCallback(clearanceFile);
                });
        }
    }

    onSelect(event: FileSelectEvent) {
        if (event.files.length >= 1)
            this.filesSelected = true;
        else this.filesSelected = false;
    }

    onProgress(event: FileProgressEvent) {
        event.progress = this.uploadProgress;
    }

}
